import React from "react";
import Editor from "../common/Editor";
import ImagePicker from "../common/ImagePicker";
const BlogForm = ({ blogForm, setBlogForm, categories, openCreateCategory }) => (

console.log("Blog form data in form component:", categories) ||
  <div className="grid grid-cols-1 gap-4">
    <div>
      <label className="mb-1 block text-xs md:text-sm font-semibold">Blog Name</label>
      <input
        type="text"
        value={blogForm.name}
        onChange={(e) => setBlogForm((f) => ({ ...f, name: e.target.value }))}
        placeholder="Enter blog title"
        onKeyDown={(e) => e.stopPropagation()}
        autoComplete="on"
        inputMode="text"
        lang="en"
        spellCheck
        autoCorrect="on"
        autoCapitalize="words"
        className="w-full rounded-lg text-xs md:text-sm border border-gray-300 px-3 py-2"
      />
    </div>
    <div className="flex w-full">
      <div className="mr-2 w-1/2">
        <label className="mb-1 block text-xs md:text-sm font-semibold">Meta Title</label>
        <input
          type="text"
          value={blogForm.metaTitle}
          onChange={(e) =>
            setBlogForm((f) => ({ ...f, metaTitle: e.target.value }))
          }
          placeholder="SEO meta title"
          maxLength={60}
          className="w-full text-xs md:text-sm rounded-lg border border-gray-300 px-3 py-2"
        />
        <div className="mt-1 text-xs text-gray-500">
          {blogForm.metaTitle?.length || 0} / 60
        </div>
      </div>
      <div className="w-1/2">
        <label className="mb-1 block text-xs md:text-sm font-semibold">Meta Description</label>
        <textarea
          className="w-full resize-y text-xs md:text-sm rounded-lg border border-gray-300 px-3 py-2"
          value={blogForm.metaDescription}
          onChange={(e) =>
            setBlogForm((f) => ({ ...f, metaDescription: e.target.value }))
          }
          placeholder="SEO meta description"
          maxLength={160}
          rows={1}
        />
        <div className="mt-1 text-xs md:text-sm text-gray-500">
          {blogForm.metaDescription?.length || 0} / 160
        </div>
      </div>
    </div>

    <div>
      <label className="mb-1 block text-xs md:text-sm font-semibold">Category</label>
      <div className="flex items-center gap-2">
        <select
          value={blogForm.category}
          onChange={(e) =>
            setBlogForm((f) => ({ ...f, category: e.target.value }))
          }
          className="rounded-lg text-xs md:text-sm border border-gray-300 bg-white px-3 py-2"
        >
          <option value="">Select a category</option>
          {categories.map((c) => (
            <option key={c.id} value={c.title}>
              {c.title}
            </option>
          ))}
        </select>
      </div>
    </div>
    <div>
      <label className="mb-1 block text-xs md:text-sm font-semibold">Description</label>
      <Editor
        data={{ descriptionData: blogForm.descriptionHtml }}
        onChange={(html) => {
          setBlogForm((f) => ({ ...f, descriptionHtml: html }));
        }}
      />
    </div>
    <div>
      <label className="mb-1 block text-xs md:text-sm font-semibold">Cover Image</label>
      <ImagePicker
        file={blogForm.imageFile}
        previewUrl={blogForm.imagePreview}
        onPick={(file) => {
          const url = URL.createObjectURL(file);
          setBlogForm((f) => ({ ...f, imageFile: file, imagePreview: url }));
        }}
        onClear={() =>
          setBlogForm((f) => ({ ...f, imageFile: null, imagePreview: "" }))
        }
        scale={blogForm.imageScale ?? 100}
        onScaleChange={(v) => setBlogForm((f) => ({ ...f, imageScale: v }))}
        fit={blogForm.file ?? "cover"}
        onFitChange={(v) => setBlogForm((f) => ({ ...f, imageFit: v }))}
      />
    </div>
  </div>
);

export default BlogForm;


